export function ajustarForm(
  form: Record<string, any>,
  regras: {
    date?: string[];
    number?: string[];
    string?: string[];
    boolean?: string[];
    custom?: Record<string, (value: any) => any>;
  },
) {
  const novoForm: Record<string, any> = { ...form };

  // Ajuste para DATE
  if (regras.date) {
    regras.date.forEach((campo) => {
      const valor = novoForm[campo];
      novoForm[campo] = valor ? new Date(valor) : null;
    });
  }

  // Ajuste para NUMBER
  if (regras.number) {
    regras.number.forEach((campo) => {
      const valor = novoForm[campo];
      novoForm[campo] =
        valor !== undefined && valor !== null ? Number(valor) : null;
    });
  }

  // Ajuste para STRING
  if (regras.string) {
    regras.string.forEach((campo) => {
      const valor = novoForm[campo];
      novoForm[campo] = valor != null ? String(valor).trim() : '';
    });
  }

  // Ajuste BOOLEAN
  if (regras.boolean) {
    regras.boolean.forEach((campo) => {
      const valor = novoForm[campo];
      novoForm[campo] = valor === 'true' || valor === true;
    });
  }

  // Ajustes CUSTOM (super flexível!)
  if (regras.custom) {
    for (const campo in regras.custom) {
      novoForm[campo] = regras.custom[campo](novoForm[campo]);
    }
  }

  return novoForm;
}
